import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { KeyTagContent, KeyTagType } from './types'

export const KeyTagGroup = ({ content }: { content: KeyTagType[] }) => (
  <Box flexDirection="row" gap="s4">
    {content.map((itemContent, index) => (
      <KeyTag key={index} content={itemContent} />
    ))}
  </Box>
)

export const KeyTag = ({ content }: { content: KeyTagType }) => {
  const customStyle: React.ComponentProps<typeof Box> =
    content.type === KeyTagContent.Text ? { paddingX: 's4' } : { width: 's16' }

  return (
    <Box
      borderRadius={{ all: 'abs004' }}
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      background="grey000White"
      justifyContent="center"
      alignItems="center"
      height="s16"
      {...customStyle}
    >
      {content.type === KeyTagContent.Text && (
        <Text.Normal size="100" weight="medium" color="grey800">
          {content.value}
        </Text.Normal>
      )}
      {content.type === KeyTagContent.Icon && <Icon.Tiny color="grey800" icon={content.value} />}
    </Box>
  )
}
